// Single source of the contact list column set (header keys live under contact.columns.*).
export const CONTACT_COLUMN_DESCRIPTORS = [
    { key: "fullName", defaultVisible: true, defaultPinned: true, locked: true },
    { key: "birthDate", defaultVisible: true },
    // #17850 enriched projection fields — opt-in (hidden by default so existing layouts don't shift).
    { key: "organisationName", defaultVisible: false },
    { key: "function", defaultVisible: false },
    { key: "category", defaultVisible: false },
    { key: "primaryEmail", defaultVisible: false },
    // Opt-in columns (OP-5828) — hidden by default so existing layouts don't shift.
    { key: "salutation", defaultVisible: false },
    { key: "status", defaultVisible: false },
    { key: "externalId", defaultVisible: false },
    { key: "createdAt", defaultVisible: false },
    { key: "updatedAt", defaultVisible: false },
    { key: "courtesy", defaultVisible: false },
    { key: "maidenName", defaultVisible: false },
    { key: "gender", defaultVisible: false },
    { key: "countryOfResidence", defaultVisible: false },
    { key: "preferredLanguage", defaultVisible: false },
    // OP-6080: primary-channel phone column on the contact list. (Email is the `primaryEmail`
    // column above.) The audience table excludes this key from its drawer — it ships its own
    // audience-specific `phone` column under the campaignDetail.audience.* namespace.
    { key: "telephone", defaultVisible: false },
];
/**
 * Derives the column-settings drawer set from the shared descriptors. The
 * locked column is emitted with `disabled: true` so OPAL keeps it visible+pinned.
 */
export function buildContactColumnSettings(t, descriptors = CONTACT_COLUMN_DESCRIPTORS) {
    return descriptors.map((d) => ({
        key: d.key,
        label: t(`contact.columns.${d.key}`),
        visible: d.defaultVisible,
        pinned: d.defaultPinned ?? false,
        ...(d.locked ? { disabled: true } : {}),
    }));
}
/**
 * Builds the rendered `DataTableColumn[]` from the shared descriptors: the
 * caller's `leadingColumns` first (the locked / sortable ones), then one opt-in
 * column per remaining descriptor for which the caller supplied a cell renderer,
 * in descriptor order. The set of columns and their order are single-sourced in
 * {@link CONTACT_COLUMN_DESCRIPTORS}; the cell renderers stay at the call site.
 */
export function buildContactDataTableColumns(opts) {
    const { optionalColumn, leadingColumns, cells } = opts;
    const descriptors = opts.descriptors ?? CONTACT_COLUMN_DESCRIPTORS;
    const leadingKeys = new Set(leadingColumns.map((c) => c.id ?? c.key).filter((k) => k != null));
    const optInColumns = descriptors
        .filter((d) => !leadingKeys.has(d.key))
        .map((d) => {
        const cell = cells[d.key];
        return cell ? optionalColumn(d.key, cell) : undefined;
    })
        .filter((c) => c != null);
    return [...leadingColumns, ...optInColumns];
}
